import { AppState } from 'web/store'

export const getCurrentDateTime = () => (state: AppState): Date | null => {
  const { currentDateTime } = state.utils
  return currentDateTime ? new Date(currentDateTime) : null
}
